// import React from 'react'

import FormField from "@/components/common/FormField"
import MainHeading from "@/components/common/MainHeading"
import Layout from "@/components/layout/Layout"
// import { ArrowLeft } from "lucide-react" 
import { useNavigate } from "react-router-dom"
import { useForm } from "react-hook-form"
import { errorTypes } from "@/utility/validation"
import { Button } from "@/components/ui/button"
import Card from "@/components/common/Card"
import { ThrowError } from "@/api/callApi"
import { DepartmentService } from "@/services/Department/Department"
import type { department, departmentResponse } from "@/interface/department.interface"
import { showToastNotification } from "@/utility/helper"
import { RoutesLink } from "@/utility/RouteLinks"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import FullPageLoader from "@/components/common/FullPageLoader"

const AddDepartment: React.FC = () => {
    const navigate = useNavigate()
    const { id } = useParams()
    const [isLoading, setIsLoading] = useState(false)
    const [isFatchLoading, setIsFatchLoading] = useState(false)
    const { register, handleSubmit, setValue, watch, formState: { errors } } = useForm<department>({
        mode: "onChange"
    });


    const handleGetDepartmentById = async () => {
        if (!id) return;
        setIsFatchLoading(true)
        try {
            const response = await DepartmentService?.getDepartmentById(id);
            if (response?.status) {
                setValue("name", response?.data?.name)
                setValue("isActive", response?.data?.isActive)
            }
            else {
                showToastNotification("danger", response?.message)
            }
        } catch (error) {
            ThrowError(error)
        }
        finally {
            setIsFatchLoading(false)
        }
    }

    useEffect(() => {
        if (id) {
            handleGetDepartmentById();
        }
    }, [id]);

    const onSubmit = async (data: department) => {
        try {
            setIsLoading(true)
            const payload = {
                name: data?.name ?? "",
                isActive: String(data?.isActive) === "true",
            }
            let response: departmentResponse;
            if (id) {
                response = await DepartmentService?.updateDepartment(payload, id);
            } else {
                response = await DepartmentService?.createDepartment(payload);
            }
            if (response?.status) {
                showToastNotification("success", response?.message)
                navigate(RoutesLink.superAdminDepartment)
            } else {
                showToastNotification("danger", response?.message)
            }
        } catch (error) {
            ThrowError(error)

        }
        finally {
            setIsLoading(false)
        }
    }

    if (isFatchLoading) {
        return (
            <Layout>
                {/* <div className="flex items-center justify-center min-h-[400px]"> */}
                <FullPageLoader />
                {/* <Spinner className="h-8 w-8 text-primary animate-spin" /> */}
                {/* </div> */}
            </Layout >
        );
    }
    return (
        <Layout>
            <div className="space-y-6">
                <MainHeading title={id ? "Edit Department" : "Add Department"} isBackButtonVisible />
                <Card>

                    <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <FormField
                                {...register("name", { ...errorTypes.required('Name'), ...errorTypes.name })}
                                type="text"
                                label="Name"
                                minLength={4}
                                maxLength={30}
                                placeholder="Enter Department Name"
                                error={errors.name?.message}
                                required
                            />
                            <FormField
                                {...register("isActive", { ...errorTypes.required("Status") })}
                                type="select"
                                label="Status"
                                value={String(watch("isActive") ?? "")}
                                options={[
                                    { value: "select", label: "Select Status" },
                                    { value: "true", label: "Active" },
                                    { value: "false", label: "Inactive" },
                                ]}
                                error={errors.isActive?.message}
                                required
                            />
                        </div>
                        <div className="flex justify-end">
                            <Button disabled={isLoading} type="submit">{isLoading ? "Submitting..." : "Submit"}</Button>
                        </div>
                    </form>
                </Card>
            </div>
        </Layout>

    )
}

export default AddDepartment